(function(history){
    var pushState = history.pushState;
    history.pushState = function(state) {
        const ret = pushState.apply(history, arguments);
        const evt = new PopStateEvent('pushstate', { state: state });
        window.dispatchEvent(evt);
        return ret;
    };
})(window.history);

export const link = (href, title, state) => {
  if (href.match(/^https?:\/\//)) {
    document.location = href;
  }
  if (state === undefined) {
    const url = new URL(href, document.location.href);
    const page = url.pathname.substr(1);
    const args = {};
    Array.from(url.searchParams.keys()).forEach(k => {
      args[k] = url.searchParams.get(k);
    });
    state = { page: page, args: args };
  }
  if (title === undefined) {
    title = document.title;
  }
  window.history.pushState(state, title, href);
  document.title = title;
};
